import React, {Component} from 'react';
import Icon from "../../../../../../../../components/icon/index";
import Button from "../../../../../../../../components/button/index";
import './index.css';
import {permissionCleaner} from "../../../../../../../../utils";
import {connect} from "react-redux";
import {rightToAdd} from "../../../../../../../../../actions/sharingDetailsActions";

class RightSelection extends Component {

    constructor(props){
        super(props);

        this.state = {
            showDropDown: false
        };

        this.showDropdown = this.showDropdown.bind(this);
        this.mouseLeaveHandler = this.mouseLeaveHandler.bind(this);
        this.selectRight = this.selectRight.bind(this);
    }

    showDropdown(){
        this.setState((state) => ({
            showDropDown: !state.showDropDown
        }))
    }

    mouseLeaveHandler(){
        this.setState({
            showDropDown: false
        })
    }

    selectRight(e){
        this.props.setRightToAdd(e.currentTarget.dataset.right);
        this.setState({
            showDropDown: false
        })
    }

    componentDidMount() {
        const hasRestrictedCollaborator = this.props.addedCollaborators && this.props.addedCollaborators.some(c => c.userRole === 'RESTRICTED_USER');
        if (hasRestrictedCollaborator && (this.props.rightToAdd === 'CAN_SHARE' || this.props.rightToAdd === 'OWNER')) {
            this.props.setRightToAdd('READ_ONLY');
        }
    }

    componentDidUpdate() {
        const hasRestrictedCollaborator = this.props.addedCollaborators && this.props.addedCollaborators.some(c => c.userRole === 'RESTRICTED_USER');
        if (hasRestrictedCollaborator && (this.props.rightToAdd === 'CAN_SHARE' || this.props.rightToAdd === 'OWNER')) {
            this.props.setRightToAdd('READ_ONLY');
        }
    }

    render() {
        const hasRestrictedCollaborator = this.props.addedCollaborators && this.props.addedCollaborators.some(c => c.userRole === 'RESTRICTED_USER');
        return (
            <div className="right-selection">
                <Button className="d-flex align-items-center text-nowrap ml-2 bg-light" onClick={this.showDropdown}>
                    {permissionCleaner(this.props.rightToAdd)} <Icon className="ml-2" name="sort-down"/>
                </Button>
                {
                    this.state.showDropDown
                    ?
                        <div className="dropdown" onMouseLeave={this.mouseLeaveHandler}>
                            <ul>
                                <li data-right="READ_ONLY" onClick={this.selectRight}>{permissionCleaner('READ_ONLY')}</li>
                                {
                                    (!this.props.selectedContactsGroup || this.props.selectedContactsGroup.directorySyncType !== "DIRECTORY_LED")
                                    && <li data-right="WRITE_ONLY" onClick={this.selectRight}>{permissionCleaner('WRITE_ONLY')}</li>
                                }
	                            {
                                    (!this.props.selectedContactsGroup || this.props.selectedContactsGroup.directorySyncType !== "DIRECTORY_LED")
                                    && <li data-right="WRITE_DELETE" onClick={this.selectRight}>{permissionCleaner('WRITE_DELETE')}</li>
	                            }
                            </ul>
                            {
                                !hasRestrictedCollaborator && (
	                                this.props.selectedContactsGroup.type !== "directory"
	                                && this.props.selectedContactsGroup.type !== "childDirectory"
	                                && this.props.selectedContactsGroup.type !== "childDirectoryLv2"
                                ) && <>
	                                <hr className="m-0"/>
	                                <ul>
		                                <li data-right="CAN_SHARE" onClick={this.selectRight}>{permissionCleaner('CAN_SHARE')}</li>
	                                </ul>
                                </>
                            }
                        </div>
                    :
                        null
                }
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        rightToAdd: state.sharingDetailsReducer.rightToAdd,
        addedCollaborators: state.sharingDetailsReducer.getAddedCollaborators,
	    selectedContactsGroup: state.contactsGroupItemReducer.getSelectedContactsGroup
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        setRightToAdd : (array) => {
            dispatch(rightToAdd(array))
        },
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(RightSelection);
